<template>
  <div>
        <div class="table-container">
          <table class="table is-fullwidth is-bordered">
            <thead>
              <tr>
                <th></th>
                <th v-t="'Admin.title'">
                </th>
                 <th v-t="'Admin.status'">
                </th>
                 <th v-t="'Admin.actions'">
                </th>
              </tr>
            </thead>
            <draggable tag="tbody" v-model="list">
            <tr
              v-for="element in orderedItems"
              :key="element._id"
            >
            <td class="has-text-centered">
            <span class="icon">
              <i class="fas fa-arrows-alt-v"></i>
            </span>
          </td>
              <td>{{ (element.title||element.shortDescription) | fieldInLanguage(language)}}</td>
              <td>
                <div class="select">
                <select :value="element.status" @input="element.status=$event.target.value; $emit('update',element)">
                  <option v-t="'Admin.enabled'" value="enabled"></option>
                  <option v-t="'Admin.disabled'" value="disabled"></option>
                </select>
              </div></td>
              <td>
                <div class="buttons is-grouped">
                   <slot name="action-buttons" :element="element">
                   </slot>
                  <a
                    @click="$emit('edit',element)"
                    class="button"
                  >
                    <span class="icon is-small">
                      <i class="fas fa-edit"></i>
                    </span>
                  </a>
                  <a
                    class="button is-danger"
                    @click="$emit('delete',element._id)"
                  >
                    <span class="icon is-small">
                      <i class="fas fa-trash"></i>
                    </span>
                  </a>
                </div>
              </td>
            </tr></draggable>
          </table>
          <div class="level">
                <p class="control">
                    <a
                      class="button is-primary"
                      v-t="'Admin.create'"
                      @click="$emit('create')"
                    >
                    </a>
                </p>
              </div>
        </div>
      </div>
</template>

<script>
import Draggable from 'vuedraggable'
import _ from 'underscore'
export default {
  props: {
    content: {
      type: Array,
      default: () => []
    },
    language: {
      type: String,
      default: null
    }
  },
  components: {
    Draggable
  },
  data () {
    return {
      items: []
    }
  },
  watch: {
    content () {
      this.items = this.content
    }
  },
  filters: {
    fieldInLanguage: (field, language) => {
      if (!field) {
        return ''
      }
      let regex = /(<([^>]+)>)/ig
      let value = field[language] || field.default

      return value.replace(regex, '')
    }
  },
  computed: {
    orderedItems () {
      return _.chain(this.items)
        .sortBy(item => {
          return -new Date(item.created).getTime()
        })
        .sortBy(item => {
          return item.order
        })
        .value()
    },
    list: {
      get () {
        return this.orderedItems
      },
      set (objects) {
        this.items = objects
        _.each(objects, async (object, index) => {
          if (object.order !== index + 1) {
            object.order = index + 1
            this.$emit('update', object)
          }
        })
      }
    }
  }

}
</script>

<style>

</style>
